export class Login {
    public usercode: string;
    public pwd: string;
    constructor(data: any = {}) {
        this.usercode = data.usercode || '';
        this.pwd = data.pwd || '';
    }
}

export class UserDetails {
    public Empno: string;
    public Empname: string;
    public EmailID: string;
    public Role: string;
    constructor(data: any = {}) {
        this.Empname = data.Empname || '';
        this.Empno = data.Empno || '';
        this.EmailID = data.EmailID || '';
        this.Role = data.Role || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/common/login/login.ts